import { Toaster } from "./components/Feedback/toast-sonner";
import Router from "./router";
import "./styles/main.scss";
import ScrollTo from "./components/Layout/ScrollTo";
import { useAuth } from "./context/AuthProvider";
import LoadingSpinner from "@/components/Loading/spinner";

function App() {
  const { isLoading } = useAuth();
  return (
    <div className="app">
      <ScrollTo />
      <div className="page-wrap">
        {isLoading ? (
          <div className="fixed left-0 top-0 w-[100dvw] h-[100dvh] flex items-center justify-center">
            <LoadingSpinner />
          </div>
        ) : (
          <Router />
        )}
      </div>
      <Toaster closeButton richColors position="top-right" />
    </div>
  );
}

export default App;
